import { Badge } from '@/components/ui/badge';
import { AlertTriangle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ForfeitBadgeProps {
  reason?: string;
  variant?: 'default' | 'detailed';
  className?: string;
}

export const ForfeitBadge = ({ reason, variant = 'default', className }: ForfeitBadgeProps) => {
  const getForfeitReason = () => {
    if (!reason) return 'Forfeited';
    
    // Format common forfeit reasons
    if (reason.includes('minimum')) return 'Insufficient Players';
    if (reason.includes('no show')) return 'Team No-Show';
    if (reason.includes('cancelled')) return 'Team Cancelled';
    
    return reason;
  };

  if (variant === 'detailed') {
    return (
      <div className={cn("flex items-center gap-2 p-2 bg-destructive/10 border border-destructive/20 rounded-lg", className)}>
        <X className="h-4 w-4 text-destructive flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-destructive">Forfeited</p>
          {reason && (
            <p className="text-xs text-muted-foreground truncate">{reason}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <Badge 
      variant="destructive" 
      className={cn("flex items-center gap-1", className)}
    >
      <AlertTriangle className="h-3 w-3" />
      {getForfeitReason()}
    </Badge>
  );
};